<template>
    <search-group title="智能表查询" @search="find" @clear="clear">
        <Row class="mb16">
            <Col span="3" class="zr-label">表类型</Col>
            <Col span="5">
                 <Select v-model="searchData.deviceType">
                    <Option  v-for="item in list.meterType" :value="item.value" :key="item.value">{{item.text}}</Option>
                </Select>
            </Col>
            <Col span="3" class="zr-label">项目名称</Col>
            <Col span="5">
                 <Select v-model="searchData.projectId">
                    <Option  v-for="item in list.projects" :value="item.value" :key="item.value">{{item.text}}</Option>
                </Select>
            </Col>
            <Col span="3" class="zr-label">房间状态</Col>
            <Col span="5">
                 <Select v-model="searchData.roomStatus">
                    <Option  v-for="item in list.roomStatus" :value="item.value" :key="item.value">{{item.text}}</Option>
                </Select>
            </Col>
        </Row>
        <Row>
            <Col span="3" class="zr-label">房间号</Col>
            <Col span="5">
                <Input type="text" v-model="searchData.roomNumber" @keyup.enter.native="find"></Input>
            </Col>
        </Row>
    </search-group>
</template>

<script type="text/ecmascript-6">
// import SearchGroup from 'components/SearchGroup/index';
import { getAll } from "api/common";
export default {
    data () {
        return {
            searchData:{
                projectId:"",
				deviceType:1,
				roomStatus:"",
                roomNumber:"",
                page:1,
                limit:10,
            },
            list:{
                meterType:[],
                projects:[],
                roomStatus:[],
            }
        }
    },
    created () {
        this.init();
    },
    components: {
        // SearchGroup
    },
    methods: {
        find() {
            this.$emit('search-data',this.searchData)
        },
        clear() {
            this.searchData.projectId = "";
            this.searchData.roomStatus = "";
            this.searchData.roomNumber = "";
        },
        init() {
            getAll().then(res => {
                this.list.meterType = res.data.meterType;
                this.list.projects = res.data.projects;
                this.list.roomStatus = res.data.roomStatus;
            })
        }
    }
}
</script>
